import { render, staticRenderFns } from "./UiRangeInput.vue?vue&type=template&id=063d5f3a&"
import script from "./UiRangeInput.vue?vue&type=script&lang=js&"
export * from "./UiRangeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports